import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Services from "@/pages/admin/Services";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/services")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-services", path: "/admin/services", title: "Cloud Admin Services", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Services /></AdminLayout>,
});
